// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-container {
  position: relative;
  height: 100vh;
  overflow: hidden;
  background: #000;
}
.carousel-container .carousel-inner {
  position: relative;
  height: 100%;
  display: flex;
  align-items: stretch;
}
.carousel-container .carousel-item {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  display: flex;
  align-items: flex-start;
  padding-top: 10px;
}
.carousel-container .carousel-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 0;
}
.carousel-container .carousel-item.active {
  opacity: 1;
}
.carousel-container .carousel-item .carousel-caption {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  color: white;
  text-shadow: 3px 3px 8px rgba(0, 0, 0, 0.8);
  max-width: 900px;
  padding: 0px;
  position: relative;
  backdrop-filter: blur(2px);
}
.carousel-container .carousel-item .carousel-organised {
  margin-top: 0px;
}
.carousel-container .carousel-item .carousel-title {
  font-size: 60px;
  font-weight: 800;
  margin-bottom: 2px;
  color: white;
}
@media (max-width: 768px) {
  .carousel-container .carousel-item .carousel-title {
    font-size: 40px;
  }
}
@media (max-width: 576px) {
  .carousel-container .carousel-item .carousel-title {
    font-size: 28px;
  }
}
.carousel-container .carousel-item .carousel-subtitle {
  font-size: 22px;
  margin-bottom: 10px;
  color: white;
  margin: 0.2rem 0;
  font-weight: 600;
}
@media (max-width: 768px) {
  .carousel-container .carousel-item .carousel-subtitle {
    font-size: 14px;
  }
}
@media (max-width: 576px) {
  .carousel-container .carousel-item .carousel-subtitle {
    font-size: 12px;
  }
}
.carousel-container .carousel-item .carousel-dates,
.carousel-container .carousel-item .carousel-location {
  font-size: 24px;
  margin-bottom: 0px;
  color: white;
  margin: 0.2rem 0;
  font-weight: 600;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .carousel-container .carousel-item .carousel-dates,
  .carousel-container .carousel-item .carousel-location {
    font-size: 14px;
    white-space: normal;
  }
}
@media (max-width: 576px) {
  .carousel-container .carousel-item .carousel-dates,
  .carousel-container .carousel-item .carousel-location {
    font-size: 12px;
    white-space: normal;
  }
}
.carousel-container .carousel-association {
  margin-bottom: 0px;
  margin-top: 0px;
}
.carousel-container .carousel-description {
  font-size: 26px;
  margin-bottom: 10px;
  color: white;
  margin: 0.25rem 0.5;
  font-weight: 600;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .carousel-container .carousel-description {
    font-size: 14px;
    white-space: normal;
  }
}
@media (max-width: 576px) {
  .carousel-container .carousel-description {
    font-size: 12px;
    white-space: normal;
  }
}
.carousel-container .carousel-divider {
  width: 60%;
  max-width: 500px;
  height: 2px;
  margin: 18px auto 8px auto;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 2px;
}
.carousel-container .carousel-logos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  flex-wrap: wrap;
  margin-top: 0px;
}
.carousel-container .carousel-logos .carousel-logo {
  width: 90px;
  height: auto;
  object-fit: contain;
}
@media (max-width: 768px) {
  .carousel-container .carousel-logos .carousel-logo {
    width: 70px;
    gap: 30px;
  }
}
@media (max-width: 576px) {
  .carousel-container .carousel-logos .carousel-logo {
    width: 50px;
    gap: 20px;
  }
}
.carousel-container .carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.95);
  font-size: 28px;
  padding: 8px 12px;
  cursor: pointer;
  transition: color 0.2s ease, transform 0.2s ease;
  z-index: 10;
}
.carousel-container .carousel-control:hover {
  color: #fff;
  transform: translateY(-50%) scale(1.08);
}
.carousel-container .carousel-control.prev {
  left: 18px;
}
.carousel-container .carousel-control.next {
  right: 18px;
}
@media (max-width: 768px) {
  .carousel-container .carousel-control {
    padding: 10px 15px;
    font-size: 18px;
  }
  .carousel-container .carousel-control.prev {
    left: 8px;
  }
  .carousel-container .carousel-control.next {
    right: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/components/carousel.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AADF;AAIE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;AAFJ;AAME;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,UAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EAEA,iBAAA;AALJ;AAOI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,UAAA;AALN;AAQI;EACE,UAAA;AANN;AASI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,2CAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EAEA,0BAAA;AARN;AAUI;EACE,eAAA;AARN;AAUI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AARN;AAUM;EANF;IAOI,eAAA;EAPN;AACF;AASM;EAVF;IAWI,eAAA;EANN;AACF;AASI;EACE,eAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAPN;AASM;EAPF;IAQI,eAAA;EANN;AACF;AAQM;EAXF;IAYI,eAAA;EALN;AACF;AAQI;;EAEE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AANN;AAQM;EATF;;IAUI,eAAA;IACA,mBAAA;EAJN;AACF;AAMM;EAdF;;IAeI,eAAA;IACA,mBAAA;EAFN;AACF;AAKE;EACE,kBAAA;EACA,eAAA;AAHJ;AAKE;EACE,eAAA;EACE,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAHN;AAKM;EARJ;IASM,eAAA;IACA,mBAAA;EAFN;AACF;AAIM;EAbJ;IAcM,eAAA;IACA,mBAAA;EADN;AACF;AAII;EACE,UAAA;EACA,gBAAA;EACA,WAAA;EACA,0BAAA;EACA,qCAAA;EACA,kBAAA;AAFN;AAKI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AAHN;AAKM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAHR;AAKQ;EALF;IAMI,WAAA;IACA,SAAA;EAFR;AACF;AAIQ;EAVF;IAWI,WAAA;IACA,SAAA;EADR;AACF;AAKE;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,uBAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gDAAA;EACA,WAAA;AAHJ;AAKI;EACE,WAAA;EACA,uCAAA;AAHN;AAMI;EACE,UAAA;AAJN;AAOI;EACE,WAAA;AALN;AAQI;EA1BF;IA2BI,kBAAA;IACA,eAAA;EALJ;EAOI;IACE,SAAA;EALN;EAQI;IACE,UAAA;EANN;AACF","sourcesContent":["$primary-color: #70b60a;\n\n.carousel-container {\n  position: relative;\n  height: 100vh;\n  overflow: hidden;\n  background: #000;\n  \n\n  .carousel-inner {\n    position: relative;\n    height: 100%;\n    display: flex;\n    align-items: stretch;\n    \n  }\n\n  .carousel-item {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-position: center;\n    opacity: 0;\n    transition: opacity 0.5s ease-in-out;\n    display: flex;\n    align-items: flex-start;\n    // justify-content: center;\n    padding-top: 10px;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: rgba(0, 0, 0, 0.5);\n      z-index: 0;\n    }\n\n    &.active {\n      opacity: 1;\n    }\n\n    .carousel-caption {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: flex-start;\n      text-align: center;\n      color: white;\n      text-shadow: 3px 3px 8px rgba(0, 0, 0, 0.8);\n      max-width: 900px;\n      padding: 0px;\n      position: relative;\n      \n      backdrop-filter: blur(2px);\n    }\n    .carousel-organised{\n      margin-top: 0px;\n    }\n    .carousel-title {\n      font-size: 60px;\n      font-weight: 800;\n      margin-bottom: 2px;\n      color: white;\n\n      @media (max-width: 768px) {\n        font-size: 40px;\n      }\n\n      @media (max-width: 576px) {\n        font-size: 28px;\n      }\n    }\n\n    .carousel-subtitle {\n      font-size: 22px;\n      margin-bottom: 10px;\n      color: white;\n      margin: 0.2rem 0;\n      font-weight: 600;\n\n      @media (max-width: 768px) {\n        font-size: 14px;\n      }\n\n      @media (max-width: 576px) {\n        font-size: 12px;\n      }\n    }\n\n    .carousel-dates,\n    .carousel-location {\n      font-size: 24px;\n      margin-bottom: 0px;\n      color: white;\n      margin: 0.2rem 0;\n      font-weight: 600;\n      white-space: nowrap;\n\n      @media (max-width: 768px) {\n        font-size: 14px;\n        white-space: normal;\n      }\n\n      @media (max-width: 576px) {\n        font-size: 12px;\n        white-space: normal;\n      }\n    }\n  }\n  .carousel-association{\n    margin-bottom: 0px;\n    margin-top: 0px;\n  }\n  .carousel-description{\n    font-size: 26px;\n      margin-bottom: 10px;\n      color: white;\n      margin: 0.25rem 0.5;\n      font-weight: 600;\n      white-space: nowrap;\n\n      @media (max-width: 768px) {\n        font-size: 14px;\n        white-space: normal;\n      }\n\n      @media (max-width: 576px) {\n        font-size: 12px;\n        white-space: normal;\n      }\n  }\n\n    .carousel-divider {\n      width: 60%;\n      max-width: 500px;\n      height: 2px;\n      margin: 18px auto 8px auto;\n      background: rgba(255,255,255,0.25);\n      border-radius: 2px;\n    }\n\n    .carousel-logos {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 60px;\n      flex-wrap: wrap;\n      margin-top: 0px;\n\n      .carousel-logo {\n        width: 90px;\n        height: auto;\n        object-fit: contain;\n\n        @media (max-width: 768px) {\n          width: 70px;\n          gap: 30px;\n        }\n\n        @media (max-width: 576px) {\n          width: 50px;\n          gap: 20px;\n        }\n      }\n    }\n\n  .carousel-control {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background: transparent;\n    border: none;\n    color: rgba(255,255,255,0.95);\n    font-size: 28px;\n    padding: 8px 12px;\n    cursor: pointer;\n    transition: color 0.2s ease, transform 0.2s ease;\n    z-index: 10;\n\n    &:hover {\n      color: #fff;\n      transform: translateY(-50%) scale(1.08);\n    }\n\n    &.prev {\n      left: 18px;\n    }\n\n    &.next {\n      right: 18px;\n    }\n\n    @media (max-width: 768px) {\n      padding: 10px 15px;\n      font-size: 18px;\n\n      &.prev {\n        left: 8px;\n      }\n\n      &.next {\n        right: 8px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
